export class VerifyAttributes{
    isZeroReimbursement?: boolean = false;
    isWelM2?: boolean = false;
    selfPayReviewComplete?: boolean = false;
    isEscalated?: boolean = false;
    isVobRequest?: boolean = false;
    isCheckOonNotes?: boolean = false;
    isPreQuote?: boolean = false;
    preQuoteComplete?: boolean = false;
}